<template>
    <div
        v-if="users"
        class="container-fluid userGroupUsersWrapper">
        <div class="d-block d-md-flex justify-content-between mb-3">
            <div class="d-block d-md-flex flex-wrap align-items-center">
                <div
                    v-if="canTagging"
                    class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <multiselect
                            v-model="search.userAuthorizerTag"
                            :options="userAuthorizerTags"
                            placeholder="管理用タグで検索"
                            :multiple="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :disabled="inProgress"
                            :optionsLimit="userAuthorizerTags.length"
                            selectLabel="選択　"
                            label="name"
                            track-by="id"
                            @input="onChangeSearchUserAuthorizerTagId"
                            @remove="onChangeSearchUserAuthorizerTagId"
                            class="authorizerMavagementTagGroupSelectWrapper tags_select">
                            <template v-slot:noOptions>選択できる管理用タグがありません</template>
                            <template v-slot:noResult>管理用タグが見つかりません</template>
                        </multiselect>
                    </div>
                </div>

                <div
                    v-if="isOrganization"
                    class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.child_group_id"
                            @change="onChangeSearchChildGroupId"
                            id="status"
                            class="form-control inputSearchPlanId">
                            <option :value="null">{{ `所属${childGroupName}で検索` }}</option>
                            <option
                                v-for="group in childGroups"
                                :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                    </div>
                </div>                
            </div>

            <div class="mt-2 text-right">
                <button
                    v-if="canAdd && parentGroup"
                    type="button"
                    class="btn btn-yokumiru-orange mr-1"
                    style="min-width: 100px;"
                    @click="showModalAuthorizerChildGroupUsersStore">
                    所属会員の追加
                </button>
                <b-button
                    variant="yokumiru-orange"
                    @click="downloadCSV"
                    :disabled="inProgress">
                    CSVダウンロード
                </b-button>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-12">
                <b-table
                    striped
                    hover
                    :items="users"
                    :fields="fields"
                    :sort-by.sync="morphState.sortBy"
                    :sort-desc.sync="morphState.sortDesc"
                    @sort-changed="fetchUsers"
                    :responsive="true"
                    class="table-bordered m-table">
                    <template v-slot:cell(full_name_kana)="data">
                        <div>{{ data.item.full_name }}</div>
                        <div class="small">{{ data.item.full_name_kana }}</div>
                        <div
                            v-if="group.is_organization && data.item.is_company"
                            class="small mt-1">
                            <a :href="`/${helper.groupTypeModel(group.group_type)}/groups/${userCompany(data.item).id}`">
                                <b-icon-building/>
                                <span>{{ userCompany(data.item).name }}</span>
                            </a>
                        </div>
                    </template>

                    <template v-slot:cell(plan_id)="data">
                        <div v-if="data.item.plan">{{ data.item.plan.name }}</div>
                    </template>

                    <template v-slot:cell(user_authorizer_tags.name)="data">
                        <div class="userAuthorizerTagsWrapper d-flex align-items-center">
                            <div
                                v-for="tag in filteredUserAuthorizerTags(data.item)"
                                class="align-baseline">
                                <div class="userAuthorizerTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(latest_consultation_start_time)="data">
                        <div v-if="data.item.latest_consultation">
                            <div class="u-palt">
                                <span class="small">
                                    {{ helper.dateForHuman(data.item.latest_consultation.start_time, 'Asia/Tokyo', { simpleYear: true }) }}
                                </span>
                                <span
                                    class="small font-weight-bold"
                                    :class="helper.dayForHumanCSS(data.item.latest_consultation.start_time , 'Asia/Tokyo')">
                                    {{ helper.dayForHuman(data.item.latest_consultation.start_time, 'Asia/Tokyo', { bracket: true }) }}
                                </span>
                            </div>
                            <div class="small">
                                {{ helper.timeForHuman(data.item.latest_consultation, 'Asia/Tokyo') }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(authorizer_id)="data">
                        <div class="text-center">
                            <input
                                v-model="authorizerId"
                                :value="data.item.id"
                                class="form-check-input radioAuthorizer"
                                type="radio"
                                @change="onChangeAuthorizer">
                        </div>
                    </template>

                    <template v-slot:cell(links)="data">
                        <b-button
                            v-if="group.authorizer_id !== data.item.id"
                            type="button"
                            class="btn btn-yokumiru-blue btn-sm m-2"
                            @click="showModalAuthorizerGroupUserEdit(data.item)">
                            編集
                        </b-button>
                        <b-button
                            v-if="canLeave && group.authorizer_id !== data.item.id"
                            type="button"
                            class="btn btn-danger btn-sm m-2"
                            @click="showModalAuthorizerGroupUserLeave(data.item)">
                            所属を解除
                        </b-button>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        :total-rows="morphState.total"
                        :per-page="morphState.per_page"
                        v-model="morphState.current_page"
                        @change="fetchUsers">
                    </b-pagination>

                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-3 mb-3">
                            <span class="small">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <authorizer-child-group-users-store-modal
            v-if="canAdd && parentGroup"
            :group="group"
            :parent-group="parentGroup"
            :joined-users="joinedUsers">
        </authorizer-child-group-users-store-modal>

        <authorizer-group-user-edit-modal
            :group="group">
        </authorizer-group-user-edit-modal>

        <authorizer-group-user-leave-modal
            v-if="canLeave"
            :group="group"
            :can-doctor-pass="canDoctorPass">
        </authorizer-group-user-leave-modal>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'
import userOrganizationUsers from "../../../store/modules/user/userOrganizationUsers";
import Multiselect from "vue-multiselect";

export default {
    components: {Multiselect},
    props: {
        timezone: {
            type: String,
            default: 'Asia/Tokyo',
        },
        parentGroup: {
            type: Object|null,
            default: null,
        },
        childGroupName: {
            type: String,
            default: '',
        },
        // 団体のグループ
        group: {
            type: Object,
            required: true,
        },
        // 法人絞り込みのグループID
        groupId: {
            type: Number,
            required: false,
        },
        canAdd: {
            type: Boolean,
            default: false,
        },
        canAuthorizer: {
            type: Boolean,
            default: false,
        },
        canLeave: {
            type: Boolean,
            default: false,
        },
        canTagging: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            search: {
                userAuthorizerTag: null,
                user_authorizer_tag_ids: null,
                child_group_id: null,
            },
            users: null,
            joinedUsers: [],
            authorizerId: null,
            userAuthorizerTags: [],
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'full_name_kana',
                    'label': `${this.$locale.patient}名`,
                    sortable: true,
                },
                {
                    'key': 'email',
                    'label': 'メールアドレス',
                    sortable: false,
                },
                {
                    'key': 'plan_id',
                    'label': 'サービス',
                    sortable: true,
                },
                {
                    'key': 'latest_consultation_start_time',
                    'label': `最新の${this.$locale.consultation_host}予約日`,
                    sortable: true,
                },
                {
                    'key': 'consultation_count',
                    'label': `${this.$locale.consultation_host}回数`,
                    sortable: true,
                },
                {
                    'key': 'links',
                    'label': '',
                    'class': 'text-center',
                    sortable: false,
                },
            ],
            childGroups: [],
        }
    },

    computed: {
        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        morphState: function () {
            if (this.isCompany) {
                return this.$store.state.userCompanyUsers
            }
            else if (this.isOrganization) {
                return this.$store.state.userOrganizationUsers
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) {
                return ''
            }
            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },

        /**
         * ドクターパスを利用可能なグループかどうか
         * @return {boolean}
         */
        canDoctorPass: function () {
            return this.group.plans.some((plan) => this.helper.isDoctorPass(plan))
        },
    },

    created: function () {
        this.authorizerId = this.group.authorizer_id
        this.childGroups = this.group.child_groups

        if (this.groupId) {
            this.search.child_group_id = this.groupId
        }

        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchUsers()
        this.fetchUserAuthorizerTags()

        if (this.canTagging) {
            this.fields.splice(4, 0, {
                'key': 'user_authorizer_tags.name',
                'label': '管理用タグ',
                sortable: false,
            })
        }
        if (this.canAuthorizer) {
            this.fields.splice(5, 0, {
                'key': 'authorizer_id',
                'label': '担当者設定',
                sortable: false,
            })
        }

        bus.$on('group-users-store', this.fetchUsers)
        bus.$on('group-user-edit', this.fetchUsers)
        bus.$on('group-user-leave', this.fetchUsers)
        bus.$on('group-groups-store', this.fetchUsers)
        bus.$on('group-group-leave', this.fetchUsers)
    },

    beforeDestroy: function () {
        bus.$off('group-users-store')
        bus.$off('group-user-edit')
        bus.$off('group-user-leave')
        bus.$off('group-groups-store')
        bus.$off('group-group-leave')
    },

    methods: {
        ...mapMutations({
            setQueryCompany: 'userCompanyUsers/setQuery',
            setQueriesCompany: 'userCompanyUsers/setQueries',
            setQueryOrganization: 'userOrganizationUsers/setQuery',
            setQueriesOrganization: 'userOrganizationUsers/setQueries',
        }),

        setQuery: function (data) {
            if (this.isCompany) {
                this.setQueryCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
        },

        setQueries: function (data) {
            if (this.isCompany) {
                this.setQueriesCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isCompany && data.userCompanyUsers) {
                    this.setQueries(data.userCompanyUsers)
                }
                else if (this.isOrganization && data.userOrganizationUsers) {
                    this.setQueries(data.userOrganizationUsers)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: async function () {
            this.search.user_authorizer_tag_ids = this.morphState.user_authorizer_tag_ids

            if(this.search.user_authorizer_tag_ids){
                const tag = this.userAuthorizerTags.find((tag) => tag.user_authorizer_tag_ids === this.search.user_authorizer_tag_ids)
                if(tag){
                    this.search.userAuthorizerTag = tag
                }
                else {
                    this.search.userAuthorizerTag = null
                    await this.setQuery({ key: 'user_authorizer_tag_ids', value: null })
                }
            }
        },

        onChangeSearchUserAuthorizerTagId: async function () {

            this.search.user_authorizer_tag_ids = this.search.userAuthorizerTag.map((tag) => tag.id)
            
            await this.setQuery({ key: 'user_authorizer_tag_ids', value: this.search.user_authorizer_tag_ids })
            await this.fetchUsers(1)
            
        },

        onChangeSearchChildGroupId: async function () {
            await this.fetchUsers()
        },

        /**
         * 会員一覧取得
         *
         * @param {number|object} param
         */
        fetchUsers: async function (param = null) {
            this.users = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.user.groups.endpoint.base
            const groupId = this.search.child_group_id || this.group.id

            // ページング表示用
            axios.get(`${endpoint}/${groupId}/users${this.buildQuery()}`)
                .then(({data}) => {
                    this.users = data.data
                    this.setQueries(data.meta)
                })

            // 所属会員すべて（所属会員の追加が可能かどうかの判定用）
            axios.get(`${endpoint}/${this.group.id}/users`)
                .then(({data}) => {
                    this.joinedUsers = data.data
                })
        },

        /**
         * 管理用タグ（担当者用）一覧取得
         */
        fetchUserAuthorizerTags: function () {
            if (!this.canTagging) return

            const endpoint = constants.user.groups.endpoint.base

            axios.get(`${endpoint}/${this.group.id}/users/tags`)
                .then(({data}) => {
                    this.userAuthorizerTags = data
                })
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            if (paginate) {
                query += `page=${this.morphState.current_page}`
                query += `&sort=${this.morphState.sortBy}`
                query += `&desc=${this.morphState.sortDesc}`
            }
            else {
                query += `sort=${this.morphState.sortBy}`
                query += `&desc=${this.morphState.sortDesc}`
            }

            if (this.morphState.user_authorizer_tag_ids) {
                query += `&user_authorizer_tag_ids=${this.morphState.user_authorizer_tag_ids.join(',')}`
            }
            return query
        },

        /**
         * 管理用タグ（担当者用）
         * @param {object} user
         * @return {array}
         */
        filteredUserAuthorizerTags: function (user) {
            if (user.user_authorizer_tags.length < 1) {
                return []
            }
            return user.user_authorizer_tags.filter((tag) => tag.authorizer_id === this.group.authorizer_id)
        },

        /**
         * 子グループ所属会員追加モーダル表示
         */
        showModalAuthorizerChildGroupUsersStore: function () {
            bus.$emit('open-modal-authorizer-child-group-users-store')
        },

        /**
         * 所属会員編集モーダル表示
         *
         * @param {object} user
         */
        showModalAuthorizerGroupUserEdit: function (user) {
            bus.$emit('open-modal-authorizer-group-user-edit', user)
        },

        /**
         * 所属解除モーダル表示
         *
         * @param {object} user
         */
        showModalAuthorizerGroupUserLeave: function (user) {
            bus.$emit('open-modal-authorizer-group-user-leave', user)
        },

        /**
         * 会員の法人を取得
         * @param {object} user
         * @return {object}
         */
        userCompany: function (user) {
            return this.helper.userCompany(user) || {}
        },

        /**
         * 担当者変更
         */
        onChangeAuthorizer: function () {
            if (!this.canAuthorizer || !this.parentGroup) {
                return
            }

            const endpoint = constants.user.groups.endpoint.base

            axios.put(`${endpoint}/${this.parentGroup.id}/groups/${this.group.id}/authorizer`, { authorizer_id: this.authorizerId })
                .then(() => {
                    bus.$emit('fetch-child-group')
                    bus.$emit('alert-success', '担当者を変更しました。')
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })
        },

        /**
         * CSVダウンロード
         */
        downloadCSV: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const groupId = this.search.child_group_id || this.group.id
            const options = { responseType : 'blob' }
            const endpoint = `${constants.user.groups.endpoint.base}/${groupId}/users/export${this.buildQuery(false)}`

            await axios.get(endpoint, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            '%s_%s一覧_%s.csv',
                            this.group.name,
                            this.$locale.patient,
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },
    },
}
</script>

<style lang="scss" scoped>
.userAuthorizerTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 120px;
    padding: 5px 0;
    box-sizing: border-box;

    .userAuthorizerTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #5834b4;
        font-size: .85em;
        background-color: #f4f2f8;
        border: 1px solid #e2dced;
        border-radius: 2px;
    }
}

.tags_select{
    width: 100%;
    min-width: 310px;
}
</style>

<style lang="scss">
.userGroupUsersWrapper {
    .b-table {
        min-width: 1200px;

        th, td {
            font-size: 0.75rem;
        }
    }
}

.authorizerMavagementTagGroupSelectWrapper {
    .multiselect__tags {
        height: 35px;
        min-height: 35px;
        padding-top: 4px;
        margin-top: 2px;
        border: 1px solid #ced4da;
        font-size: 13px;
    }
    .multiselect__placeholder {
        color: #495057;
    }
}
</style>
